import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@material-ui/core";
import { useContext, useState } from "react";
import { ticketContext } from "views/Ticket/TicketContext"
import { Form, Formik } from "formik"
import * as yup from "yup"
import axios from "axios";
import { useSnackbar } from "notistack";
import EditForm from "./EditForm";
import { EditIconButton } from "components";
import { TypeInfo } from "helpers/enums";
import { applicationContext } from "helpers/services";


let EditTicketInformations = () => {
    let { enqueueSnackbar } = useSnackbar();

    let { ticketTypes } = useContext(applicationContext);
    let { ticket, getTicket } = useContext(ticketContext)

    let ticketHeaderSchema = yup.object({
        id: yup.string().default(''),
        title: yup.string().default('').required('Title is mandatory'),
        supplier: yup.string().default('').required('Supplier is mandatory'),
        ticketTypeId: yup.string().default('').required('Ticket type is mandatory'),
        reporter: yup.string().default('').required('Type in the name of a customer or colleague'),
        reporterName: yup.string().default(''),
        ticketTypeInfo: yup.string().default(''),
        issueServiceType: yup.string().default('')
            .when("ticketTypeInfo", {
                is: TypeInfo.Delivery,
                then: yup.string().default('').required('Please provide issue service type'),
                otherwise: yup.string().default('')
            })
    })

    type TicketHeader = yup.InferType<typeof ticketHeaderSchema>;

    let [open, setOpen] = useState(false);


    let editInformations = async (value: TicketHeader) => {
        try {
            await axios.post('/api/Ticket/UpdateTicketInformations', value);
            enqueueSnackbar(`saved sucessfully`, { variant: 'success' });
            getTicket();
            setOpen(false);

        } catch (e) { }
    }


    return (
        <>
            {ticket.hasCustomerServiceAssignee &&
                <EditIconButton size="medium" onClick={() => setOpen(true)} />
            }
            {open === true &&
                <Dialog maxWidth='md' fullWidth open={open}>
                    <DialogTitle disableTypography>
                        <Typography variant="h4">Edit ticket informations</Typography>
                    </DialogTitle>

                    <Formik
                        enableReinitialize={true}
                        validationSchema={ticketHeaderSchema}
                        initialValues={{
                            ...ticketHeaderSchema.getDefault(),
                            id: ticket.id,
                            supplier: ticket.supplier,
                            ticketTypeId: ticket.ticketTypeId,
                            ticketTypeInfo: ticketTypes.getValueByKey(ticket.ticketTypeId, 'id', 'typeInfo'),
                            title: ticket.title,
                            reporter: ticket.reporter,
                            reporterName: ticket.reporterName,
                            issueServiceType: ticket.issueServiceType || ''
                        }}
                        onSubmit={async (values, action) => {
                            if (values.ticketTypeId !== ticket.ticketTypeId && window.confirm("Are you sure that you want to change ticket type? Some informations will be cleared.") === false)
                                return;

                            action.setSubmitting(true);
                            await editInformations(values);
                        }}
                    >
                        {form =>
                            <Form>
                                <DialogContent>
                                    <EditForm ticketTypeId={ticket.ticketTypeId} schema={ticketHeaderSchema} />
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => setOpen(false)} color="primary" disabled={form.isSubmitting}>
                                        Cancel
                                    </Button>
                                    <Button type="submit" color="secondary" disabled={form.isSubmitting}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Form>
                        }
                    </Formik>
                </Dialog>
            }
        </>
    )
}

export default EditTicketInformations;